module.exports = __webpack_public_path__ + "img/drawer_user_active.f4759530.svg";